import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ChangeUserPasswordResult } from '../../../core/services/user-settings.service';

export const userPasswordActions = createActionGroup({
  source: 'User password',
  events: {
    password_change_page_open: emptyProps(),
    password_change_start: props<{ oldPassword: string; newPassword: string }>(),
    password_change_success: emptyProps(),
    password_change_failure: props<{ status: ChangeUserPasswordResult }>()
  }
});
